module.exports = __webpack_public_path__ + "static/img/chatCode.4c9ce0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chatCode.jpg
// module id = bJLp
// module chunks = 1